import { createAsyncThunk } from '@reduxjs/toolkit';

import collaboratorModel from '@/models/collaborator';

export const fetchCollaborators = createAsyncThunk(
	'collaborators/fetchCollaborators',
	async (_, { rejectWithValue, getState }) => {
		try {
			const { searchTerm } = getState().collaborators;
			const options = {};

			if (searchTerm) {
				options.email = searchTerm;
			}

			const response = await collaboratorModel.list(options);

			return response.rows;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const createCollaborator = createAsyncThunk(
	'collaborators/createCollaborator',
	async (data, { rejectWithValue, dispatch }) => {
		try {
			const response = await collaboratorModel.create({
				...data
			});

			dispatch(fetchCollaborators());

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const editCollaborator = createAsyncThunk(
	'collaborators/editCollaborator',
	async (data, { rejectWithValue, dispatch }) => {
		try {
			const response = await collaboratorModel.edit(data);

			if (!response.success) {
				throw new Error(response.statusText);
			}

			dispatch(fetchCollaborators());

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const deleteCollaborator = createAsyncThunk(
	'collaborators/deleteCollaborator',
	async (id, { rejectWithValue, dispatch }) => {
		try {
			const response = await collaboratorModel.deleteCollaborator(id);

			if (!response.success) {
				throw new Error(response.statusText);
			}

			dispatch(fetchCollaborators());

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const sendCollaboratorInvitation = createAsyncThunk(
	'collaborators/sendInvitation',
	async (id, { rejectWithValue }) => {
		try {
			const response = await collaboratorModel.sendInvitation(id);

			if (!response.success) {
				throw new Error(response.statusText);
			}

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);
